import { motion } from "framer-motion";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import SectionHeading from "@/components/SectionHeading";
import { useSectionContent } from "@/hooks/useContent";

export default function Direttivo() {
  const c = useSectionContent("direttivo");
  const { data: members = [] } = useQuery({
    queryKey: ["board-members"],
    queryFn: async () => (await api.get("/board-members")).data,
  });

  if (members.length === 0) return null;

  return (
    <section
      id="direttivo"
      data-testid="direttivo-section"
      className="py-24 sm:py-32 px-5 sm:px-8 bg-[#121215]"
    >
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          overline={c.overline}
          title={c.title}
          description={c.description}
          testid="direttivo-heading"
        />

        <div className="mt-14 grid grid-cols-2 lg:grid-cols-4 gap-5" data-testid="direttivo-grid">
          {members.map((m, i) => (
            <motion.article
              key={m.id}
              data-testid={`board-member-${m.id}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="leather-card group overflow-hidden"
            >
              <div className="relative overflow-hidden aspect-[3/4]">
                <img
                  src={m.photo_url}
                  alt={m.name}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0B]/95 via-[#0A0A0B]/10 to-transparent" />
                <div className="absolute bottom-0 inset-x-0 p-5">
                  <h3 className="font-display text-lg font-semibold text-[#F4EBE1]">{m.name}</h3>
                  <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.25em] text-[#C5A059]">
                    {m.role}
                  </p>
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
